import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';

interface NgxChartSeriesPoint {
  name: number;   // x-axis value (H)
  value: number;  // y-axis value (B)
}

interface NgxChartSeries {
  name: string;
  series: NgxChartSeriesPoint[];
}

@Component({
  selector: 'app-material',
  templateUrl: './material.component.html',
  styleUrls: ['./material.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgxChartsModule]
})
export class MaterialComponent implements OnInit {
  id: string;
  material: any;
  materialJson: string;
  chartData: NgxChartSeries[];
  hasApiError = false;
  apiError: string;

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    private route: ActivatedRoute
  ) { }

  mapBHCurveToNgxCharts(input: any): NgxChartSeries[] {
    const hEntry = input.data.find(
      (d: any) => d.name === 'non-linear permeability H'
    );

    const bEntry = input.data.find(
      (d: any) => d.name === 'non-linear permeability B'
    );

    if (!hEntry || !bEntry) {
      throw new Error('H or B permeability data not found');
    }

    const hValues: number[] = hEntry.value.magnitude;
    const bValues: number[] = bEntry.value.magnitude;

    if (hValues.length !== bValues.length) {
      throw new Error('H and B data arrays must have the same length');
    }

    const series: NgxChartSeriesPoint[] = hValues.map((h, index) => ({
      name: h,
      value: bValues[index]
    }));

    return [
      {
        name: 'B-H Curve',
        series
      }
    ];
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.api.getMaterialsId$(this.id).subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.material = res;
        this.materialJson = JSON.stringify(this.material, null, 2).trim();
        this.chartData = this.mapBHCurveToNgxCharts(this.material);
      },
      error: () => this.hasApiError = true,
    });
  }
}
